import { Field, getIn } from 'formik';
import React from 'react';
import { Col } from 'react-bootstrap';
import { FormikInput, FormikSelect } from '../../components';

const BookkeeperItems = props => {
  const { errors, touched, totalBalances, setFieldValue, index, selectOptions } = props;

  return (
    <>
      <Col md={3}>
        <Field name={`bookkeeper[bookkeeperItems][${index}][account]`}>
          {({ field }) => (
            <FormikInput
              {...field}
              abbr
              label="Cuenta Contable"
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`bookkeeper[bookkeeperItems][${index}][recordId]`}>
          {({ field }) => (
            <FormikSelect
              isClearable
              label="Condición"
              options={selectOptions}
              placeholder="Seleccionar Condición"
              onChange={data => setFieldValue(field.name, data ? data.value : '')}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`bookkeeper[bookkeeperItems][${index}][majorAccount]`}>
          {({ field }) => (
            <FormikInput
              {...field}
              label="Cuenta Mayor"
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
            />
          )}
        </Field>
        {totalBalances}
      </Col>
    </>
  );
};
export default BookkeeperItems;
